module.exports = __webpack_public_path__ + "media/images/new_landing/logos/nivea-5272898e45e25d0bcba1a4fe4d9785b3.png";